// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import Api from './api/index'
import axios from 'axios'
import router from './router'
import store from './vuex/store'
import {util, Env} from './assets/js/util'
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import './assets/iconfont/iconfont.css'
import './assets/css/base.css'
import './assets/css/common.css'
import './assets/css/viewer.css'
import {Common} from './assets/js/huangye/common'
import {TransitionEnd$1} from './assets/js/huangye/transitionend'
Vue.prototype.oldRoot = null
// 保存全景实例
window.pano = null
// 保存三维实例
window.model = null

Vue.use(Api)
Vue.prototype.Swiper = Swiper
Vue.prototype.Env = Env()
Vue.prototype.util = util

Vue.prototype.axios = axios
Vue.prototype.Common = Common
Vue.directive('transitionEnd', TransitionEnd$1)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js